// app/translate/translate.pipe.ts

import { Injectable, Pipe, PipeTransform } from "@angular/core";
import { LoginService } from "../services/login.service";

// tslint:disable-next-line:pipe-naming
@Pipe({
  name: "hcurrency", // currency is already used, so we must use hcurrency
  // impure pipe - the pipe is called every time change detection runs (which is usually quite often).
  // pure: false // impure pipe, update value when we change language
  pure: true, // better UI performance
})
@Injectable({
  providedIn: "root", // ✅ or 'any'
})
export class HCurrencyPipe implements PipeTransform {
  private currencyMap = {
    CZK: "Kč",
    EUR: "€",
    USD: "$",
  };

  constructor(private loginService: LoginService) {}

  transform(value: any, currencyIsoCode?: string, abs: boolean = false, hideDecimal: boolean = false): any {
    if (isNaN(value)) {
      return value;
    }

    if (abs) {
      value = Math.abs(value);
    }

    // if currencyIsoCode is not found, load currency from this.loginService.user?.CurrencyCode
    if (!currencyIsoCode) {
      currencyIsoCode = this.loginService.user?.CurrencyCode || "CZK";
    }

    const symbol = this.currencyMap[currencyIsoCode] || "";

    return this.formatMoney(value, symbol, hideDecimal ? 0 : 2);
  }

  formatMoney(
    input: number,
    symbol = "",
    decimalPlaces = 2, // number of decimal places to display
    thousandsSeparatorGroupSize = 3, // number of digits between thousands separators
    thousandsSeparator = "\u00A0", // non-breaking space
    decimalSeparator = ",", // comma as decimal separator
  ): string {
    if (input === null || input === undefined) {
      return "";
    }

    const endAnchor = decimalPlaces > 0 ? "\\D" : "$";
    const regex = `\\d(?=(\\d{${thousandsSeparatorGroupSize || 3}})+${endAnchor})`;
    const formattedNumberString = Number(input).toFixed(Math.max(0, ~~decimalPlaces));

    if (!symbol) {
      symbol = "";
    }

    const formattedNumber = (decimalSeparator ? formattedNumberString.replace(".", decimalSeparator) : formattedNumberString).replace(
      new RegExp(regex, "g"),
      `$&${thousandsSeparator || ","}`,
    );

    // use Unicode non-breaking space so interpolation works and prevents line-breaks
    return symbol.length > 0 ? `${formattedNumber}\u00A0${symbol}` : formattedNumber;
  }
}
